import React from 'react'
import Typed from 'react-typed'
import AppMovil from '../../asset/images/Home/AppMobile.png'
import AppWeb from '../../asset/images/Home/AppWeb.png'
import BI from '../../asset/images/Home/BI.png'
import IA from '../../asset/images/Home/IA.png'
import Analitica from '../../asset/images/Home/Analitica.png'
import LoginModal from '../login/LoginModal'
import UsersPanel from '../users-panel/UsersPanel'
import './intro.scss'

export default function Intro() {
  const [isScrolled, setIsScrolled] = React.useState(false)
  const [loginOpen, setLoginOpen] = React.useState(false)
  const [usersOpen, setUsersOpen] = React.useState(false)
  const [user, setUser] = React.useState(null)

  React.useEffect(() => {
    // Check if user is already logged in
    const storedUser = localStorage.getItem('user')
    if (storedUser) {
      setUser(JSON.parse(storedUser))
    }
  }, [])

  const handleScrollToContacts = () => {
    const contactsSection = document.querySelector('.contacts')
    if (contactsSection) {
      contactsSection.scrollIntoView({ behavior: 'smooth' })
    }
  }

  const handleLoginSuccess = (userData) => {
    setUser(userData)
  }

  const handleLogout = () => {
    setUser(null)
  }

  const handleInitiarSesion = () => {
    if (user) {
      setUsersOpen(true)
    } else {
      setLoginOpen(true)
    }
  }

  React.useEffect(() => {
    const onScroll = () => setIsScrolled(window.pageYOffset !== 0)
    window.addEventListener('scroll', onScroll)
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  return (
    <section className={'intro' + (isScrolled ? ' scrolled' : '')} aria-labelledby="intro-heading">
      <LoginModal open={loginOpen} onClose={() => setLoginOpen(false)} onLoginSuccess={handleLoginSuccess} />
      <UsersPanel open={usersOpen} onClose={() => setUsersOpen(false)} user={user} onLogout={handleLogout} />

      <div className="intro-container">
        <div className='intro-header'>
          <div className='right btn'>
            <button
              aria-label={user ? 'Panel de usuario' : 'Iniciar sesión'}
              onClick={handleInitiarSesion}
            >
              {user ? `${user.name}` : 'Iniciar Sesión'}
            </button>
            {!user && (
              <button aria-label="Registrarse" onClick={handleScrollToContacts}>
                Registrarse
              </button>
            )}
          </div>
        </div>

        <div className='hero-section'>
          <div className='content'>
            <div>
              <div className='title-logo'>
                <img src={require('../../asset/images/Ingeniosoft-textoblanco.png').default} height={50} alt="IngenioSoft" className={isScrolled ? 'logo scrolled' : 'logo'} />
                <h1 id="intro-heading">Ingeniosoft <span className='circule'>360</span></h1>
              </div>
              <h2>
                Especialistas en soluciones digitales:
              </h2>
              <h3>
                <Typed
                  strings={[
                    'Diseño y construcción de aplicaciones web.',
                    'Diseño y construcción de aplicaciones móviles.',
                    'Analítica de datos y visualización.',
                    'Inteligencia de negocios.',
                    'Incursión en Inteligencia Artificial para productos.'
                  ]}
                  typeSpeed={40}
                  backSpeed={20}
                  loop
                />
              </h3>
              <p className="intro-cta">Transformamos tus ideas en realidad con tecnología de punta.</p>
            </div>
          </div>
        </div>
        
        <div className='content-services'>
          <div className='service'>
            <img src={AppMovil} alt="Ingeniosoft app movile" className='logo-service' />
            <h3>Aplicaciones Móviles</h3>
          </div>
          <div className='service'>
            <img src={AppWeb} alt="Ingeniosoft app web" className='logo-service' />
            <h3>Aplicaciones Web</h3>
          </div>
          <div className='service'>
            <img src={Analitica} alt="Ingeniosoft app movile" className='logo-service' />
            <h3>Analitica y Visualización</h3>
          </div>
          <div className='service'>
            <img src={BI} alt="Ingeniosoft app movile" className='logo-service' />
            <h3>Ingeligencia de Negocios</h3>
          </div>
          <div className='service'>
            <img src={IA} alt="Ingeniosoft app movile" className='logo-service' />
            <h3>Inteligencia Artificial</h3>
          </div>
        </div>
      </div>
    </section>
  )
}